import { Reveal } from "@components/ui";

interface EmergencyCTASectionProps {
  title: string;
  subtitle: React.ReactNode;
  children: React.ReactNode;
}

export function EmergencyCTASection({ title, subtitle, children }: EmergencyCTASectionProps) {
  return (
    <section className="w-full overflow-hidden bg-[#fffcfb] px-5 py-10 md:px-10 md:py-14 lg:px-[180px] lg:py-[102px]">
      <div className="mx-auto w-full max-w-[1368px]">
        {/* CTA Card */}
        <Reveal direction="none" initialScale={0.97}>
          <div className="relative flex h-auto w-full items-center overflow-hidden rounded-[12px] md:rounded-[24px] bg-[#f03813] lg:h-[440px]">
            {/* Decorative Lines - Hidden on Mobile */}
            <div className="pointer-events-none absolute inset-0 hidden lg:block">
              {/* Top vertical bars */}
              <div
                className="absolute h-[251px] w-[31px] bg-[#fff8f6]"
                style={{ top: "-112px", left: "778.5px" }}
              />
              <div
                className="absolute h-[251px] w-[31px] bg-[#fff8f6]"
                style={{ top: "-150px", left: "873.5px" }}
              />
              <div
                className="absolute h-[251px] w-[31px] bg-[#fff8f6]"
                style={{ top: "-180px", left: "1077.8px" }}
              />
              <div
                className="absolute h-[251px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "-173.03px",
                  left: "968.5px",
                  transform: "rotate(-3.3deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[251px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "-154.01px",
                  left: "1236.88px",
                  transform: "rotate(14.8deg)",
                  transformOrigin: "0 0",
                }}
              />
              {/* Curved right side bars */}
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "-41.04px",
                  left: "1470.61px",
                  transform: "rotate(52.5deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "162.29px",
                  left: "1579.4px",
                  transform: "rotate(83.3deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "385.91px",
                  left: "1547.9px",
                  transform: "rotate(114.1deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  top: "595.64px",
                  left: "1486.6px",
                  transform: "rotate(144.9deg)",
                  transformOrigin: "0 0",
                }}
              />
              {/* Bottom bars */}
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  bottom: "-420px",
                  right: "-30px",
                  transform: "rotate(144.9deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  bottom: "-510px",
                  right: "192px",
                  transform: "rotate(175.8deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  bottom: "-525px",
                  right: "324px",
                  transform: "rotate(-176.1deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  bottom: "-525px",
                  right: "409px",
                  transform: "rotate(-176.1deg)",
                  transformOrigin: "0 0",
                }}
              />
              <div
                className="absolute h-[302.5px] w-[31px] bg-[#fff8f6]"
                style={{
                  bottom: "-490px",
                  right: "516px",
                  transform: "rotate(-176.1deg)",
                  transformOrigin: "0 0",
                }}
              />
            </div>

            {/* Content */}
            <div className="relative z-10 flex w-full flex-col items-start gap-6 px-4 py-6 md:gap-8 md:px-6 md:py-10 lg:flex-row lg:items-center lg:gap-[200px] lg:px-[77px] lg:py-[83px]">
              {/* Text Content */}
              <div className="flex max-w-full flex-col items-start gap-4 lg:w-[617px] lg:shrink-0 lg:gap-[19px]">
                <h2 className="font-albert-sans text-[28px] font-bold leading-[1.1] tracking-[-0.04em] text-[#fffcfb] md:text-[40px] lg:max-w-[488px] lg:text-[54px]">
                  {title}
                </h2>
                <div className="font-albert-sans text-[14px] md:text-base font-medium tracking-[-0.04em] text-[#fffcfb] lg:text-[28px]">
                  {subtitle}
                </div>
              </div>

              {/* Right Content */}
              <div className="flex shrink-0 flex-col items-start">
                {children}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
